module.exports = __webpack_public_path__ + "static/img/highway-12-wayside-exhibits10.abfc48a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pages/highway-12/highway-12-wayside-exhibits10.jpg
// module id = 910
// module chunks = 0